





































import { AccountTypeEnum, TenantUserModel } from '@/libs/Api';
import Page from '@/Page.vue';
import { Guid } from '@/libs/common/functions/guid';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { tenantUsersStore } from '@/libs/tenants/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';

@Component({})
export default class InviteAccountDialog extends Page {

    dialog = false;
    valid = false;
    saving = false;
    userExists = false;
    mainDistrictId = null;
    email = "";
    accountType: AccountTypeEnum = AccountTypeEnum.Worker;
    basicRules = [
        (v: any) => !!v || this.$t('validation.thisFieldIsRequired')
    ];

    @Watch("dialog")
    dialogChanged(v: boolean) {
        if (!v)
            this.close();
    }

    @Ref() form!: any;
    @Prop() tenantId!: string;

    open () {
        this.email = "";
        this.dialog = true;
        this.userExists = false;
    }

    close () {
        this.dialog = false;
    }

    save () {
        if (this.form.validate()) {
            this.saving = true;
            this.userExists = false;
            tenantUsersStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<TenantUserModel>(undefined, [
                { field: "user.email", op: "eq", comparand: this.email }
            ], undefined, false, "UserExistsCheck"));
            this.subscribe(tenantUsersStore, CrudReponse.GetAll, "UserExistsCheck").then((e: TenantUserModel[]) => {
                if (e.length == 0) {
                    const InviteTenantUserModel: TenantUserModel = {
                        id: "00000000-0000-0000-0000-000000000000",
                        user: {
                            id: "00000000-0000-0000-0000-000000000000",
                            email: this.email
                        },
                        accountType: this.accountType!,
                        mainDistrictId: this.mainDistrictId
                    };
                    tenantUsersStore.dispatch(CrudAction.Create, { item: InviteTenantUserModel });
                    this.subscribe(tenantUsersStore, CrudReponse.Create).then(() => {
                        this.close();
                        this.saving = false;
                        this.$emit("change");
                    }).catch(() => {
                        this.close();
                        this.saving = false;
                        this.$emit("change");
                    });
                }
                else {
                    this.saving = false;
                    this.userExists = true;
                }
            }).catch(() => {
                this.saving = false;
            });
            
        }
    }

    deleteClick () {
        console.log("deleteClick")
    }

}
